/* @flow */

export const validation ={
  maxTitleChar: 100,
  maxParagraphChar: 600
}